import { render, staticRenderFns } from "./DestinationState.vue?vue&type=template&id=10b0ad4e&scoped=true&"
import script from "./DestinationState.vue?vue&type=script&lang=js&"
export * from "./DestinationState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0ad4e",
  null
  
)

export default component.exports